'use strict';

exports.__esModule = true;
exports.enterIntercept = enterIntercept;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _CookieUtil = require('../util/CookieUtil');

var _CookieUtil2 = _interopRequireDefault(_CookieUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sessionId = void 0,
    ssid = void 0,
    type = void 0;

function GetUrlParams(url) {
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf('?') + 1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

function enterIntercept(nextState, replace, callback) {
    ssid = GetUrlParams(window.location.href)["ssid"] ? GetUrlParams(window.location.href)["ssid"] : ssid = _CookieUtil2.default.get('ssid');
    type = GetUrlParams(window.location.href)["type"] == 2 ? GetUrlParams(window.location.href)["type"] : 1;
    if (ssid && type) {
        _axios2.default.get('/api/bp/auth?ssid=' + ssid + (type ? '&t=' + type : '')).then(function (response) {
            if (response.data.success) {
                sessionId = response.data.data.sessionId;
                _axios2.default.post('/api/bp/check', { 'mac': sessionId, 'ssid': ssid, 'type': type }).then(function (response) {
                    if (response.data.data.accessRight) {
                        replace({
                            pathname: '/'
                        });
                    } else {
                        replace({
                            pathname: '/overPaid'
                        });
                        callback();
                    }
                });
            }
            callback();
        }).catch(function (error) {
            replace({
                pathname: '/403'
            });
            callback();
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/router/enterIntercept.js
// module id = 561
// module chunks = 0